import styled from 'styled-components';
import { ConstraintContainer } from 'src/components/common/ConstraintContainer';
import { ProductDTO } from 'src/models/pim';
import { ProductPageShowcaseGallery } from 'src/modules/products/components/ProductPage/ProductPageShowcase/ProductPageShowcaseGallery';
import { ProductPageShowcaseDetails } from 'src/modules/products/components/ProductPage/ProductPageShowcase/ProductPageShowcaseDetails';
import { media } from 'src/styles/designs';
import { Theme } from 'vendor/mods/styled-components';
import { redTheme } from 'src/styles/theme';
import React, { FC, ReactNode } from 'react';
import { Button } from 'src/components/common/Button';
import { useTranslate } from 'react-t7e';
import { MailDefault } from 'src/components/icons/MailDefault';
import { DispatchOnClick } from 'src/components/common/DispatchOnClick';

const StyledButton = styled(Button)`
  margin-top: 24px;
`;

export interface ProductPageShowcaseProps {
  product: ProductDTO;
  children: ReactNode;
}

const Container = styled.header`
  padding: 24px 0;
  background: ${({ theme }) => theme.palette.background};

  ${media.w.greaterThanOrEqual.desktop} {
    padding: 56px 0;
  }
`;

const ContentContainer = styled(ConstraintContainer)`
  display: flex;
  flex-direction: column;
  gap: 32px;

  ${media.w.greaterThanOrEqual.desktop} {
    flex-direction: row;
    gap: 120px;
  }
`;

export const ProductPageShowcase: FC<ProductPageShowcaseProps> = ({
  product,
  children,
}) => {
  const { _ } = useTranslate();
  return (
    <Theme theme={redTheme}>
      <Container>
        <ContentContainer>
          <ProductPageShowcaseGallery {...product} />
          <ProductPageShowcaseDetails product={product}>
            {children}
            <DispatchOnClick type="modalOpen" payload={{ kind: 'contact' }}>
              <StyledButton icon={MailDefault} variant="secondary">
                {_(' Contact us')}
              </StyledButton>
            </DispatchOnClick>
          </ProductPageShowcaseDetails>
        </ContentContainer>
      </Container>
    </Theme>
  );
};
